import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const List = lazy(() => import('./List'))
const Detail = lazy(() => import('./:id/Index'))

export const DisputesRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--disputes']}>
    <Route index element={<List />} />
    <Route path=':id/*' element={<Detail />} />
  </SubRouter>
))
